import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ApplicationUIContext } from '../../components/Provider/Provider';
import { colors } from 'ui-library/styles/colors';

const StyledContentWrapper = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  gap: ${({ isMobile }) => (isMobile ? '16px' : '24px')};
  margin: 0;
  padding: ${({ isMobile }) => (isMobile ? '24px 8px' : '16px 24px')};
  background: ${colors.neutral[2]};
`;

const ContentWrapper = ({ children }) => {
  const { isMobile } = React.useContext(ApplicationUIContext);

  return (
    <StyledContentWrapper size={isMobile ? 'middle' : 'large'} isMobile={isMobile}>
      {children}
    </StyledContentWrapper>
  );
};

ContentWrapper.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
};

export { ContentWrapper };
